import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import type { VacationReceipt } from '../../../models/vacationReceipt.types';
import { vacationReceiptService } from '../../../services/vacationReceiptService';
import { DOWNLOAD_RECEIPT_LABEL } from '../vacationRequestDetailsModal.definitions';

export interface DownloadReceiptActionProps {
    receipt: Pick<VacationReceipt, 'storagePath' | 'fileUrl'>;
    label?: string;
}

export function DownloadReceiptAction({ receipt, label }: DownloadReceiptActionProps) {
    return (
        <button
            type="button"
            onClick={() => void vacationReceiptService.openFile(receipt)}
            className="inline-flex items-center gap-1.5 rounded-xl border border-primary-200 bg-white px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50 font-montserrat"
        >
            <ArrowDownTrayIcon className="h-4 w-4" aria-hidden="true" />
            {label ?? DOWNLOAD_RECEIPT_LABEL}
        </button>
    );
}

export default DownloadReceiptAction;
